import { api } from './api'
import type {
  DashboardSummary,
  DashboardRoleGroup,
  DashboardStats,
  PptQueueSnapshot,
  PptPipeline,
  PptBatchReadiness,
  PptExceptions,
} from '../types/dashboard'

export const dashboardService = {
  getSummary: async (role?: DashboardRoleGroup): Promise<DashboardSummary> => {
    const response = await api.get<DashboardSummary>('/dashboard/summary', {
      params: role ? { role } : undefined,
    })
    return response.data
  },
  getStats: async (): Promise<DashboardStats> => {
    const response = await api.get<DashboardStats>('/dashboard/stats')
    return response.data
  },
  getPptQueueSnapshot: async (): Promise<PptQueueSnapshot> => {
    const response = await api.get<PptQueueSnapshot>('/dashboard/ppt/queue-snapshot')
    return response.data
  },
  getPptPipeline: async (): Promise<PptPipeline> => {
    const response = await api.get<PptPipeline>('/dashboard/ppt/pipeline')
    return response.data
  },
  getPptBatchReadiness: async (): Promise<PptBatchReadiness> => {
    const response = await api.get<PptBatchReadiness>('/dashboard/ppt/batch-readiness')
    return response.data
  },
  getPptExceptions: async (limit = 25): Promise<PptExceptions> => {
    const response = await api.get<PptExceptions>('/dashboard/ppt/exceptions', { params: { limit } })
    return response.data
  },
}

